import React from 'react';
import style from './paintworkBox.scss';
import { isNil } from '../../../services/helper';
import Price from '../../util/Price';

function PaintworkBox(props) {
    const { paintwork, selectedItem, onSelectItem, markedDependencies } = props;

    let containerStyle = style.container;
    let isSelected = false;
    let isMarked = false;
    let serialParentUid = 0;

    if (isNil(selectedItem)) {
        if (paintwork.preselected || paintwork.mandatory) {
            onSelectItem(paintwork);
        }
    } else if (paintwork.uid === selectedItem.uid) {
        isSelected = true;
        serialParentUid = selectedItem.serial_parent_uid;
        containerStyle = style.container__active;
    }

    for (let i = 0; i < markedDependencies.length; i += 1) {
        if (markedDependencies[i] === paintwork.uid) {
            isMarked = true;
        }
    }

    if (isMarked) {
        containerStyle += ` ${style.container__marked}`;
    }

    const onChange = () => {
        if (paintwork.mandatory) {
            return null;
        }
        return onSelectItem(paintwork);
    };

    return (
        <label htmlFor={paintwork.uid}>
            <input className={style.radio} type="radio" value={paintwork.name} id={paintwork.uid} checked={isSelected} onChange={() => onChange()} />
            <div className={containerStyle}>
                <div className={style.colorImage}>
                    <img src={`/${paintwork.image}`} alt={paintwork.name} />
                </div>
                <div className={style.details}>
                    <p>{paintwork.name}</p>
                    <h4><Price value={props.resolvePrice(paintwork, serialParentUid)} /></h4>
                </div>
            </div>
        </label>
    );
}
export default PaintworkBox;
